import {
  getGridDateOperators,
  getGridNumericOperators,
  getGridSingleSelectOperators,
  getGridStringOperators,
  type GridFilterOperator,
} from '@mui/x-data-grid';

const STRING_OPERATOR_VALUES = ['contains', 'equals', 'startsWith', 'endsWith', 'isAnyOf'] as const;
const SINGLE_SELECT_OPERATOR_VALUES = ['is', 'not', 'isAnyOf'] as const;
const DATE_OPERATOR_VALUES = ['is', 'not', 'after', 'onOrAfter', 'before', 'onOrBefore'] as const;
const NUMERIC_OPERATOR_VALUES = ['=', '!=', '>', '>=', '<', '<='] as const;

export const getStringFilterOperators = (): GridFilterOperator[] =>
  getGridStringOperators().filter((operator) =>
    STRING_OPERATOR_VALUES.includes(operator.value as (typeof STRING_OPERATOR_VALUES)[number]),
  );

export const getSingleSelectFilterOperators = (): GridFilterOperator[] =>
  getGridSingleSelectOperators().filter((operator) =>
    SINGLE_SELECT_OPERATOR_VALUES.includes(
      operator.value as (typeof SINGLE_SELECT_OPERATOR_VALUES)[number],
    ),
  );

export const getDateFilterOperators = (): GridFilterOperator[] =>
  getGridDateOperators().filter((operator) =>
    DATE_OPERATOR_VALUES.includes(operator.value as (typeof DATE_OPERATOR_VALUES)[number]),
  );

export const getNumericFilterOperators = (): GridFilterOperator[] =>
  getGridNumericOperators().filter((operator) =>
    NUMERIC_OPERATOR_VALUES.includes(operator.value as (typeof NUMERIC_OPERATOR_VALUES)[number]),
  );
